import { createTranslations } from '@momentum/i18n';
import { interactionsEnTranslations } from './interactions.en';

export const interactionsHeTranslations = createTranslations(
  interactionsEnTranslations,
  {
    // Wizard selection page
    interactionWizards: 'אשפי אינטראקציה',
    wizardsDescription:
      'בחר את סוג השיחה המקצועית שברצונך לנהל. האשפים שלנו ידריכו אותך בתהליך מובנה ליצירת אינטראקציות משמעותיות מסוג I See You ו-I Need You.',
    praiseWizard: 'אשף I See You',
    praiseSubtitle: 'שתף חוויות חיוביות במקום העבודה',
    praiseDescription:
      'הכר בעבודה מצוינת, חגוג הישגים וחזק מערכות יחסים באמצעות משוב חיובי מובנה. מושלם להדגשת הצלחות ובניית מורל הצוות.',
    recognitionAndAppreciation: 'הכרה והערכה',
    goalImpactAssessment: 'הערכת השפעה על מטרות',
    companyValuesAlignment: 'התאמה לערכי החברה',
    startPraiseWizard: 'התחל אשף I See You',
    feedbackWizard: 'אשף I Need You',
    feedbackSubtitle: 'שתף משוב בונה',
    feedbackDescription:
      'ספק משוב בונה שיעזור לעמיתים לצמוח ולהשתפר. התמקד בהתנהגויות ספציפיות והשפעתן כדי ליצור שיחות פיתוח משמעותיות.',
    constructiveDevelopmentFeedback: 'משוב פיתוחי בונה',
    stakeholderImpactAssessment: 'הערכת השפעה על בעלי עניין',
    organizationalImpactAnalysis: 'ניתוח השפעה ארגונית',
    startFeedbackWizard: 'התחל אשף I Need You',
    wizardsFooter:
      'בחר את האשף המתאים ביותר לצרכי השיחה שלך. כל אשף מספק גישה מובנית לתקשורת ומשוב במקום העבודה.',

    // Interactions table
    iSeeU: 'I See You',
    iNeedU: 'I Need You',
    iLearn: 'I Learn',
    sent: 'נשלח',
    draft: 'טיוטה',
    actionPlan: 'תכנית פעולה',
    finished: 'הושלם',
    actionRequired: 'נדרשת פעולה',
    unknown: 'לא ידוע',
    noData: 'אין נתונים',
    loadingInteractions: 'טוען אינטראקציות...',
    noInteractionsFound: 'לא נמצאו אינטראקציות',
    tryAdjustingFilters: 'נסה לשנות את המסננים או ליצור אינטראקציה חדשה',
    filters: 'מסננים',
    search: 'חיפוש',
    searchByParticipant: 'חיפוש לפי משתתף...',
    type: 'סוג',
    allTypes: 'כל הסוגים',
    status: 'סטטוס',
    allStatuses: 'כל הסטטוסים',
    fromDate: 'מתאריך',
    toDate: 'עד תאריך',
    pendingFeedbackAlert: 'יש לך משוב ממתין שדורש טיפול. אנא בדוק והשלם אותם.',
    createdByMe: 'כיוזם',
    participatedIn: 'כמשתתף',
    participant: 'משתתף אחד',
    participants: 'משתתפים',
    date: 'תאריך',
    goal: 'מטרה',
    noGoal: 'ללא יעד מקושר',
    reason: 'סיבה',
    latestInteractions: 'אינטראקציות אחרונות',
    latestInteractionsSubtitle:
      'האינטראקציות האחרונות שלך מסוג I See You ו-I Need You',
  }
);
